import { defineModule } from '@kubdee/sdk'
import { MODULES } from '@kubdee/shared'
import { migrations } from './migrations'
import { salesDoctypes } from './doctypes'

// 🔄 To change icon, also add the new icon to apps/web/src/lib/icon-registry.ts
const MODULE_ICON = 'ShoppingCart'
const MODULE_COLOR = '#2490EF'

export default defineModule({
  name: MODULES.SALES,
  label: 'การขาย',
  icon: MODULE_ICON,
  color: MODULE_COLOR,
  version: '1.0.0',
  dependencies: [MODULES.CORE, MODULES.ACCOUNTING],
  category: 'finance',
  isSystemModule: false,

  schemas: {},
  routes: {},
  navigation: {
    label: 'การขาย',
    icon: MODULE_ICON,
    groups: [
      {
        label: 'ภาพรวม',
        items: [
          { label: 'แดชบอร์ด', path: '/sales/dashboard', icon: 'LayoutDashboard' },
        ],
      },
      {
        label: 'ข้อมูลหลัก',
        items: [
          { label: 'ลูกค้า', path: '/sales/customers', icon: 'Users' },
          { label: 'สินค้า/บริการ', path: '/sales/items', icon: 'Package' },
        ],
      },
      {
        label: 'ธุรกรรมขาย',
        items: [
          { label: 'ใบเสนอราคา', path: '/sales/quotations', icon: 'FileText' },
          { label: 'ใบสั่งขาย', path: '/sales/sales-orders', icon: 'FileText' },
        ],
      },
      {
        label: 'รายงาน',
        items: [
          { label: 'รายงานการขาย', path: '/sales/reports', icon: 'BarChart3' },
        ],
      },
    ],
  },
  permissions: {},
  hooks: {},

  doctypes: [
    { key: "customers", label: "ลูกค้า" },
    { key: "quotations", label: "ใบเสนอราคา", type: "submittable", branchScope: { type: "single", fields: ["branchId"], createField: "branchId" } },
    { key: "quotation-items", label: "รายการใบเสนอราคา", branchScope: { type: "inherit" } },
    { key: "sales-orders", label: "ใบสั่งขาย", type: "submittable", branchScope: { type: "single", fields: ["branchId"], createField: "branchId" } },
    { key: "sales-order-items", label: "รายการใบสั่งขาย", branchScope: { type: "inherit" } },
  ],
  availableHooks: [
    { event: "sales.quotation.submitted", label: "ยืนยันใบเสนอราคา" },
    { event: "sales.quotation.convertedToOrder", label: "แปลงใบเสนอราคาเป็นใบสั่งขาย" },
    { event: "sales.quotation.converted", label: "แปลงใบเสนอราคาเป็นใบแจ้งหนี้" },
    { event: "sales.order.submitted", label: "ยืนยันใบสั่งขาย" },
    { event: "sales.order.converted", label: "แปลงใบสั่งขายเป็นใบแจ้งหนี้" },
    { event: "sales.order.cancelled", label: "ยกเลิกใบสั่งขาย" },
  ],

  fixtures: [],

  moduleMigrations: migrations,

  // Doctype Admin Epic (#347) issue B1 (#356). See `./doctypes.ts` — the
  // platform boot loop in `apps/tenant-worker/src/middleware/auto-migrate.ts`
  // reads this field from every enabled module's manifest and upserts the
  // platform-default rows into `core_doctype_registry`.
  registeredDoctypes: salesDoctypes,
})
